// Copyright (c) 2017 Deere & Company

export const stripQuotes = string => string.replace(/^(['"])+|(['"])+$/g, '');



// WEBPACK FOOTER //
// ./src/shared/services/strip-quotes.js